export default {
  title_1_1: 'Secret',
  title_1_2: 'Safe Box',
  desc_1_2: 'Solide, sécurisé et simple',

  title_2_1: 'Tout nouveau',
  title_2_2: 'Design',
  desc_2_1:
    'Procédé de fabrication entièrement laser, panneau épaissi pour une meilleure protection',
  desc_2_2: 'Plus de vis, plus de verrous de sécurité, ajustement plus serré',
  desc_2_3: 'Prend en charge 2 ensembles de mnémoniques de 12 mots',
  desc_2_4:
    'Fabrication laser, panneau épaissi et protection accrue ; davantage de vis/verrous pour un ajustement serré ; prise en charge de 2×12 mots',

  title_3_1_1: 'Impressionnantes',
  title_3_1_2: 'caractéristiques 3-en-1',
  desc_3_1:
    'Entièrement fabriqué en acier inoxydable 304 pour une résistance au feu, à la chaleur et à la corrosion',
  desc_3_2: 'Étanche',
  desc_3_3_1: 'Acier inoxydable 304 de qualité',
  desc_3_3_2: 'Étanche et anticorrosion',
  desc_3_3_3: 'Adapté aux environnements de stockage',
  desc_3_3_4: 'Protège facilement les clés',
  desc_3_4: 'Ignifuge',
  desc_3_5_1: 'Température de fusion très élevée',
  desc_3_5_2: 'Excellentes performances au feu',
  desc_3_5_3: 'Vos clés restent en sécurité',
  desc_3_5_4: 'même lors d’un incendie imprévu',
  desc_3_6: 'Antichoc',
  desc_3_7_1: 'Procédé de fabrication haute résistance',
  desc_3_7_2: 'Panneaux plus épais pour un meilleur ajustement',
  desc_3_7_3: 'même en cas de chocs imprévus',
  desc_3_7_4: 'Protège fermement chaque caractère à l’intérieur',

  title_4_1: 'Panneau alphabétique',
  desc_4_1_1: 'Version Pro du panneau alphabétique',
  desc_4_1_2: 'Plus pratique, plus efficace',
  desc_4_2_1:
    'Nouveau design : 6 panneaux démontables pour obtenir 351 blocs',
  desc_4_2_2:
    'Prise en charge des majuscules/minuscules, ajout des chiffres et symboles',
  desc_4_2_3:
    'Conception double face, jusqu’à 702 caractères affichables',
  desc_4_3: '351 blocs',
  desc_4_4: 'Majuscules/minuscules',
  desc_4_5: 'Chiffres/symboles',
  desc_4_6: 'Double face',

  title_5_1: 'Schéma d’utilisation',
  desc_5_1:
    'Compatible avec l’extension de portefeuille Web. Parfaitement adapté à TokenPocket, alliant sécurité et simplicité.',
  desc_5_2: 'Étape 01',
  desc_5_3: 'Déployer le panneau avant et ouvrir dans le sens antihoraire',
  desc_5_4: 'Étape 02',
  desc_5_5: 'Desserrer les 5 vis avec un tournevis',
  desc_5_6: 'Étape 03',
  desc_5_7: 'Soulever le panneau de couverture',
  desc_5_8: 'Étape 04',
  desc_5_9: 'Insérer les caractères dans les fentes',
  desc_5_10: 'Étape 05',
  desc_5_11:
    'Après vérification, refermer le panneau avant et resserrer les 5 vis',

  title_6_1: 'Spécifications / Contenu',
  desc_6_1: 'Secret Box Pro',
  desc_6_2:
    'Par rapport à la copie papier, Secret Box Pro mise sur la sécurité et la praticité : démontage/assemblage aisés, placement rapide des blocs.',
  desc_6_3: 'Panneau alphabétique',
  desc_6_4:
    'Par rapport à la copie papier, Secret Box Pro mise sur la sécurité et la praticité : démontage/assemblage aisés, placement rapide des blocs.',
  desc_6_5: 'Pochette EVA',
  desc_6_6:
    'Par rapport à la copie papier, Secret Box Pro mise sur la sécurité et la praticité : démontage/assemblage aisés, placement rapide des blocs.',
  desc_6_7: 'Brochure/vis/tournevis',
  desc_6_8:
    'Par rapport à la copie papier, Secret Box Pro mise sur la sécurité et la praticité : démontage/assemblage aisés, placement rapide des blocs.',

  title_7_1: 'Spécifications techniques',
  title_7_2: 'Fonctions et utilisation',
  desc_7_1: 'Spécifications de la Secret Box',
  desc_7_2: 'Taille',
  desc_7_3: 'Poids',
  desc_7_4: 'Spécifications du panneau alphabétique',
  desc_7_5: 'Ensemble de 3 pièces, 351 blocs de caractères au total',
  desc_7_6: 'Prend en charge plusieurs ensembles de mnémoniques',
  desc_7_7:
    'Prend en charge 2×12 mots ou 1×18/24 mots (protocole BIP39).',
  desc_7_8: 'Stockage hors ligne',
  desc_7_9:
    'Grâce au stockage hors ligne, Secret Box Pro élimine le risque de vol des clés via le réseau',
  desc_7_10: 'Matériaux de haute qualité',
  desc_7_11:
    'L’acier inoxydable robuste convient à une conservation durable des mnémoniques, loin des soucis de perte.',
};
